import * as React from 'react'
import { useEmbeddable } from '../use-embeddable'
import { IonCard, IonCardContent, IonLoading, IonText } from '@ionic/react'

function Embeddable(props: { token: string }) {
  return React.createElement('em-beddable', props)
}

function AccountAnalytics({ id }: { id: string }) {
  const embedable = useEmbeddable(id)

  if (embedable.isLoading) return <IonLoading isOpen message="Loading..." />

  return (
    <>
      {embedable.data ? (
        <>
          <IonCard>
            <IonCardContent>
              <Embeddable token={embedable.data} />
            </IonCardContent>
          </IonCard>
        </>
      ) : (
        <IonText>There was an error loading the analytics</IonText>
      )}
    </>
  )
}

export default AccountAnalytics
